const getAreaCoords = elementBoundingRect => ({
	x1: elementBoundingRect.x,
	x2: elementBoundingRect.x + elementBoundingRect.width,
	y1: elementBoundingRect.y,
	y2: elementBoundingRect.y + elementBoundingRect.height,
})

export default getAreaCoords
